import React, { createContext, useState, useLayoutEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import lightTheme from 'utils/themeLight'
import darkTheme from 'utils/themeDark'

export const ThemeContext = createContext()

export const ThemeContextProvider = ({ children }) => {
   const [theme, setTheme] = useState('light')

   // Check for saved theme or system preference on first render
   useLayoutEffect(() => {
      const savedTheme = document.cookie.split('; ').find((row) => row.startsWith('theme='))
      const initialTheme = savedTheme
         ? savedTheme.split('=')[1]
         : window.matchMedia('(prefers-color-scheme: dark)').matches
         ? 'dark'
         : 'light'

      setTheme(initialTheme)
      document.documentElement.setAttribute('data-theme', initialTheme)
   }, [])

   // Function to toggle theme
   const toggleTheme = () => {
      const newTheme = theme === 'light' ? 'dark' : 'light'
      setTheme(newTheme)
      document.documentElement.setAttribute('data-theme', newTheme)
      document.cookie = `theme=${newTheme}; path=/;`
   }

   return (
      <ThemeContext.Provider value={{ theme, toggleTheme }}>
         <ThemeProvider theme={theme === 'dark' ? darkTheme : lightTheme}>{children}</ThemeProvider>
      </ThemeContext.Provider>
   )
}
